// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import Modal from "react-modal";

Modal.setAppElement("#root");

// Global peker til SW
let waitingServiceWorker;
let setShowUpdate;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App setShowUpdateCallback={(cb) => (setShowUpdate = cb)} />
  </React.StrictMode>
);

// Registrer SW og håndter oppdatering både mens appen kjører og etter gjenåpning
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log("[SW] Ny versjon oppdaget");
    waitingServiceWorker = registration.waiting;
    if (setShowUpdate) {
      setShowUpdate(true); // vis banner
    }
  },
  onSuccess: (registration) => {
    // Hvis ny versjon allerede var klar ved app-start
    if (registration.waiting) {
      console.log("[SW] Ny versjon var klar ved oppstart");
      waitingServiceWorker = registration.waiting;
      if (setShowUpdate) {
        setShowUpdate(true);
      }
    }
  }
});

// Kalles fra banner når bruker trykker "Oppdater nå"
export function updateApp() {
  if (waitingServiceWorker) {
    console.log("[SW] Bruker valgte å oppdatere – sender SKIP_WAITING");
    waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log("[SW] Controller byttet – reloader app");
      window.location.reload();
    });
  }
}

reportWebVitals();
